<script>
function emptyTotals() {
  return {
    own_perf_share: 0,
    own_mech_share: 0,
    own_sync_share: 0,
    collection_perf_share: 0,
    collection_mech_share: 0,
    collection_sync_share: 0,
  };
}

function shareNum(item, camelKey, snakeKey) {
  if (!item) {
    return 0;
  }
  if (item[camelKey] != null && item[camelKey] !== "") {
    return Number(item[camelKey] || 0);
  }
  if (item[snakeKey] != null && item[snakeKey] !== "") {
    return Number(item[snakeKey] || 0);
  }
  return 0;
}

function addToTotals(target, item) {
  target.own_perf_share += shareNum(item, "own_perf_share", "own_perf_share");
  target.own_mech_share += shareNum(item, "own_mech_share", "own_mech_share");
  target.own_sync_share += shareNum(item, "own_sync_share", "own_sync_share");
  target.collection_perf_share += shareNum(item, "collection_perf_share", "collection_perf_share");
  target.collection_mech_share += shareNum(item, "collection_mech_share", "collection_mech_share");
  target.collection_sync_share += shareNum(item, "collection_sync_share", "collection_sync_share");
}

export default {
  name: "SongDetailContent",
  props: {
    config: {
      type: Object,
      default: function () {
        return {};
      },
    },
    workId: {
      type: String,
      default: "",
    },
    showChrome: {
      type: Boolean,
      default: true,
    },
    showActions: {
      type: Boolean,
      default: true,
    },
  },
  data: function () {
    return {
      loading: true,
      error: "",
      song: {},
      contributors: { melody: [], lyrics: [], arrangement: [], publisher: [] },
      audioSrc: "",
      audioFileName: "",
      hasSavedAudio: false,
      videoSrc: "",
      videoFileName: "",
      hasSavedVideo: false,
      playing: false,
      currentTime: 0,
      duration: 0,
      volume: 0.85,
      muted: false,
      draggingFile: false,
    };
  },
  computed: {
    activeWorkId: function () {
      var fromProp = String(this.workId || "").trim();
      if (fromProp) {
        return fromProp;
      }
      return String((this.config && this.config.workId) || "").trim();
    },
    listUrl: function () {
      var base = String((this.config && this.config.basePath) || "");
      return (base === "" ? "" : base) + "/main-manage-song.php?page=song_list_all";
    },
    editBasicUrl: function () {
      var url = String((this.config && this.config.editBasicUrl) || "").trim();
      if (url) {
        return url;
      }
      var base = String((this.config && this.config.basePath) || "");
      return (base === "" ? "" : base) + "/main-manage-song.php?page=song_add&mode=edit&section=basic&work_id=" + encodeURIComponent(this.activeWorkId);
    },
    editShareUrl: function () {
      var url = String((this.config && this.config.editShareUrl) || "").trim();
      if (url) {
        return url;
      }
      var base = String((this.config && this.config.basePath) || "");
      return (base === "" ? "" : base) + "/main-manage-song.php?page=song_add&mode=edit&section=share&work_id=" + encodeURIComponent(this.activeWorkId);
    },
    pageTitle: function () {
      return this.txt(this.song.title_local || this.song.title_eng);
    },
    artistLabel: function () {
      var rows = this.artistRows;
      if (!rows.length) {
        return "ไม่ระบุศิลปิน";
      }
      return rows.join(" / ");
    },
    progressPct: function () {
      if (!this.duration) {
        return 0;
      }
      return Math.min(100, Math.max(0, (this.currentTime / this.duration) * 100));
    },
    artistRows: function () {
      return this.nameRows(this.song && this.song.artists, ["artist_name", "artistName", "artist"]);
    },
    albumRows: function () {
      return this.nameRows(this.song && this.song.albums, ["album_name", "albumName", "album"]);
    },
    roleSections: function () {
      return [
        { key: "melody", label: "ทำนอง", dot: "melody", rows: this.contributors.melody || [] },
        { key: "lyrics", label: "เนื้อร้อง", dot: "lyrics", rows: this.contributors.lyrics || [] },
        { key: "arrangement", label: "เรียบเรียง", dot: "arrangement", rows: this.contributors.arrangement || [] },
        { key: "publisher", label: "Publisher", dot: "publisher", rows: this.contributors.publisher || [] },
      ];
    },
    summaryRows: function () {
      var c = this.contributors || {};
      var writerTotals = emptyTotals();
      var publisherTotals = emptyTotals();
      var grandTotals = emptyTotals();
      var seen = {};
      var groups = ["melody", "lyrics", "arrangement", "publisher"];
      var i;
      var j;
      var list;
      var item;
      var role;
      var uniq;
      for (i = 0; i < groups.length; i++) {
        list = Array.isArray(c[groups[i]]) ? c[groups[i]] : [];
        for (j = 0; j < list.length; j++) {
          item = list[j] || {};
          role = String(item.role_code || "").toUpperCase();
          uniq = String(item.member_id || "") + "|" + role + "|" + String(item.sort_order || "");
          if (seen[uniq]) {
            continue;
          }
          seen[uniq] = true;
          if (role === "E") {
            addToTotals(publisherTotals, item);
          } else {
            addToTotals(writerTotals, item);
          }
        }
      }
      addToTotals(grandTotals, writerTotals);
      addToTotals(grandTotals, publisherTotals);
      return [
        { label: "นักแต่ง (ทำนอง/เนื้อร้อง/เรียบเรียง)", totals: writerTotals, strong: false },
        { label: "Publisher", totals: publisherTotals, strong: false },
        { label: "รวมทั้งหมด", totals: grandTotals, strong: true },
      ];
    },
  },
  watch: {
    activeWorkId: function () {
      this.resetAudio();
      this.loadSongDetail();
    },
  },
  mounted: function () {
    this.loadSongDetail();
  },
  beforeUnmount: function () {
    this.resetAudio();
  },
  methods: {
    txt: function (v) {
      var s = String(v || "").trim();
      return s === "" ? "-" : s;
    },
    pct: function (n) {
      return Number(n || 0).toFixed(2);
    },
    sharePct: function (item, camelKey, snakeKey) {
      return this.pct(shareNum(item, camelKey, snakeKey));
    },
    pick: function (obj, keys) {
      var i;
      var k;
      var v;
      if (!obj || !Array.isArray(keys)) {
        return "";
      }
      for (i = 0; i < keys.length; i++) {
        k = keys[i];
        if (!Object.prototype.hasOwnProperty.call(obj, k)) {
          continue;
        }
        v = obj[k];
        if (v !== null && v !== undefined && String(v).trim() !== "") {
          return v;
        }
      }
      return "";
    },
    nameRows: function (list, keys) {
      var raw;
      var parts;
      var out = [];
      if (Array.isArray(list)) {
        list.forEach(function (item) {
          var name = String(item && typeof item === "object" ? item.name || item.value || "" : item || "").trim();
          if (name) {
            out.push(name);
          }
        });
        if (out.length) {
          return out;
        }
      }
      raw = String(this.pick(this.song, keys) || "").trim();
      if (raw === "" || raw === "-") {
        return [];
      }
      parts = raw.split(/\r\n|\n|\r|\s*\/\s*|,\s*/);
      parts.forEach(function (part) {
        var name = String(part || "").trim();
        if (name) {
          out.push(name);
        }
      });
      return out;
    },
    toThaiDateTime: function (raw) {
      var t = String(raw || "").trim();
      var d;
      if (t === "") {
        return "-";
      }
      d = new Date(t.replace(" ", "T"));
      if (isNaN(d.getTime())) {
        return t;
      }
      return d.toLocaleString("th-TH", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      });
    },
    toThaiDate: function (raw) {
      var t = String(raw || "").trim();
      var d;
      if (t === "") {
        return "-";
      }
      d = new Date(t);
      if (isNaN(d.getTime())) {
        return t;
      }
      return d.toLocaleDateString("th-TH", { year: "numeric", month: "2-digit", day: "2-digit" });
    },
    formatTime: function (sec) {
      var n = Number(sec || 0);
      var m;
      var s;
      if (!isFinite(n) || n < 0) {
        n = 0;
      }
      m = Math.floor(n / 60);
      s = Math.floor(n % 60);
      return String(m) + ":" + (s < 10 ? "0" : "") + String(s);
    },
    resetAudio: function () {
      var audio = this.$refs.audioEl;
      var video = this.$refs.videoEl;
      if (audio) {
        audio.pause();
        audio.removeAttribute("src");
        audio.load();
      }
      if (video) {
        video.pause();
        video.removeAttribute("src");
        video.load();
      }
      if (this.audioSrc && String(this.audioSrc).indexOf("blob:") === 0) {
        URL.revokeObjectURL(this.audioSrc);
      }
      this.audioSrc = "";
      this.audioFileName = "";
      this.hasSavedAudio = false;
      this.videoSrc = "";
      this.videoFileName = "";
      this.hasSavedVideo = false;
      this.playing = false;
      this.currentTime = 0;
      this.duration = 0;
      this.draggingFile = false;
    },
    applySavedMedia: function () {
      var audioUrl = String((this.song && (this.song.audio_url || this.song.audioUrl)) || "").trim();
      var videoUrl = String((this.song && (this.song.video_url || this.song.videoUrl)) || "").trim();
      if (audioUrl) {
        this.hasSavedAudio = true;
        this.audioSrc = audioUrl;
        this.audioFileName = String(this.song.audio_original_name || this.song.audioOriginalName || "ไฟล์เสียง MP3");
      }
      if (videoUrl) {
        this.hasSavedVideo = true;
        this.videoSrc = videoUrl;
        this.videoFileName = String(this.song.video_original_name || this.song.videoOriginalName || "ไฟล์วิดีโอ MP4");
      }
    },
    openAudioPicker: function () {
      var input = this.$refs.audioInput;
      if (input) {
        input.click();
      }
    },
    onAudioPicked: function (event) {
      var files = event && event.target && event.target.files ? event.target.files : null;
      this.loadAudioFile(files && files[0] ? files[0] : null);
      if (event && event.target) {
        event.target.value = "";
      }
    },
    onAudioDrop: function (event) {
      var files;
      event.preventDefault();
      this.draggingFile = false;
      if (this.hasSavedAudio) {
        return;
      }
      files = event.dataTransfer && event.dataTransfer.files ? event.dataTransfer.files : null;
      this.loadAudioFile(files && files[0] ? files[0] : null);
    },
    loadAudioFile: function (file) {
      var self = this;
      var name;
      if (!file) {
        return;
      }
      name = String(file.name || "").toLowerCase();
      if (String(file.type || "").indexOf("audio/") !== 0 && !/\.(mp3|wav|m4a|aac|ogg|flac|webm)$/.test(name)) {
        return;
      }
      if (this.audioSrc && String(this.audioSrc).indexOf("blob:") === 0) {
        URL.revokeObjectURL(this.audioSrc);
      }
      this.hasSavedAudio = false;
      this.audioSrc = URL.createObjectURL(file);
      this.audioFileName = file.name || "ไฟล์เสียง";
      this.playing = false;
      this.currentTime = 0;
      this.duration = 0;
      this.$nextTick(function () {
        var audio = self.$refs.audioEl;
        if (audio) {
          audio.src = self.audioSrc;
          audio.volume = self.muted ? 0 : self.volume;
          audio.load();
        }
      });
    },
    togglePlay: function () {
      var audio = this.$refs.audioEl;
      if (!this.audioSrc) {
        this.openAudioPicker();
        return;
      }
      if (!audio) {
        return;
      }
      if (this.playing) {
        audio.pause();
        return;
      }
      audio.play();
    },
    onAudioPlay: function () {
      this.playing = true;
    },
    onAudioPause: function () {
      this.playing = false;
    },
    onAudioTime: function () {
      var audio = this.$refs.audioEl;
      if (!audio) {
        return;
      }
      this.currentTime = audio.currentTime || 0;
      this.duration = audio.duration && isFinite(audio.duration) ? audio.duration : this.duration;
    },
    onAudioMeta: function () {
      var audio = this.$refs.audioEl;
      if (!audio) {
        return;
      }
      this.duration = audio.duration && isFinite(audio.duration) ? audio.duration : 0;
      audio.volume = this.muted ? 0 : this.volume;
    },
    onAudioEnded: function () {
      this.playing = false;
      this.currentTime = 0;
    },
    seekAudio: function (event) {
      var audio = this.$refs.audioEl;
      var val = Number(event && event.target ? event.target.value : 0);
      if (!audio || !this.duration) {
        return;
      }
      audio.currentTime = (val / 100) * this.duration;
      this.currentTime = audio.currentTime;
    },
    changeVolume: function (event) {
      var audio = this.$refs.audioEl;
      var val = Number(event && event.target ? event.target.value : 85) / 100;
      this.volume = Math.min(1, Math.max(0, val));
      this.muted = this.volume === 0;
      if (audio) {
        audio.volume = this.muted ? 0 : this.volume;
      }
    },
    toggleMute: function () {
      var audio = this.$refs.audioEl;
      this.muted = !this.muted;
      if (audio) {
        audio.volume = this.muted ? 0 : this.volume;
      }
    },
    loadSongDetail: function () {
      var self = this;
      var apiUrl = String((this.config && this.config.apiUrl) || "").trim();
      if (!this.activeWorkId) {
        this.loading = false;
        this.error = "ไม่พบ Work ID";
        return;
      }
      if (apiUrl === "") {
        this.loading = false;
        this.error = "ไม่พบที่อยู่ API ของข้อมูลเพลง";
        return;
      }
      this.loading = true;
      this.error = "";
      this.resetAudio();
      this.song = {};
      this.contributors = { melody: [], lyrics: [], arrangement: [], publisher: [] };
      var params = new URLSearchParams();
      params.set("work_id", this.activeWorkId);
      fetch(apiUrl + "?" + params.toString(), {
        credentials: "same-origin",
        headers: { Accept: "application/json" },
      })
        .then(function (res) {
          return res.json();
        })
        .then(function (json) {
          if (!json || (json.success !== true && json.success !== true)) {
            throw new Error(json && json.message ? json.message : "โหลดข้อมูลไม่สำเร็จ");
          }
          self.song = json.song || {};
          self.contributors = Object.assign(
            { melody: [], lyrics: [], arrangement: [], publisher: [] },
            json.contributors || json.contributors || {}
          );
          self.applySavedMedia();
          self.loading = false;
        })
        .catch(function (err) {
          self.loading = false;
          self.error = err && err.message ? err.message : "โหลดข้อมูลไม่สำเร็จ";
        });
    },
  },
};
</script>

<template>
  <div>
    <div v-if="showChrome" class="row">
      <div class="col-12">
        <div class="page-title-box d-sm-flex align-items-center justify-content-between bg-galaxy-transparent">
          <h4 class="mb-sm-0">ดูข้อมูลเพลง</h4>
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item"><a href="javascript:void(0);">จัดการเพลง</a></li>
              <li class="breadcrumb-item"><a :href="listUrl">รายการเพลงทั้งหมด</a></li>
              <li class="breadcrumb-item active">ดูข้อมูลเพลง</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <div v-if="error" class="alert alert-danger" role="alert">{{ error }}</div>

    <div class="card mb-3">
      <div class="card-body d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-3">
        <div>
          <h5 class="mb-1">{{ loading ? "กำลังโหลด..." : pageTitle }}</h5>
          <div class="text-muted small">Work ID: <span>{{ txt(song.work_id || activeWorkId) }}</span></div>
        </div>
        <a v-if="showChrome" :href="listUrl" class="btn btn-light">กลับไปรายการเพลง</a>
      </div>
    </div>

    <div class="card mb-3">
      <div class="card-header d-flex align-items-center justify-content-between gap-2 flex-wrap">
        <h5 class="card-title mb-0">ข้อมูลพื้นฐานเพลง</h5>
        <a v-if="showActions" :href="editBasicUrl" class="btn btn-sm btn-primary">แก้ไขข้อมูลพื้นฐานเพลง</a>
      </div>
      <div class="card-body">
        <div class="song-meta-grid">
          <div class="song-meta-item song-col-3">
            <div class="song-meta-label">Work ID</div>
            <div class="song-meta-value">{{ txt(song.work_id || activeWorkId) }}</div>
          </div>
          <div class="song-meta-item song-col-3">
            <div class="song-meta-label">ISRC</div>
            <div class="song-meta-value">{{ txt(song.isrc) }}</div>
          </div>
          <div class="song-meta-item song-col-3">
            <div class="song-meta-label">ISWC</div>
            <div class="song-meta-value">{{ txt(song.iswc) }}</div>
          </div>
          <div class="song-meta-item song-col-3">
            <div class="song-meta-label">วันที่สร้าง</div>
            <div class="song-meta-value">{{ toThaiDateTime(song.created_at) }}</div>
          </div>
          <div class="song-meta-item song-meta-item--primary song-col-6">
            <div class="song-meta-label">ชื่อเพลง (ไทย)</div>
            <div class="song-meta-value">{{ txt(song.title_local) }}</div>
          </div>
          <div class="song-meta-item song-meta-item--primary song-col-6">
            <div class="song-meta-label">ชื่อเพลง (อังกฤษ)</div>
            <div class="song-meta-value">{{ txt(song.title_eng) }}</div>
          </div>
          <div class="song-meta-item song-col-12">
            <div class="song-meta-label">เนื้อร้องขึ้นต้น</div>
            <div class="song-meta-value">{{ txt(pick(song, ["lyrics_intro", "lyricsIntro"])) }}</div>
          </div>
          <div class="song-meta-item song-col-6">
            <div class="song-meta-label">ศิลปิน</div>
            <div v-if="artistRows.length" class="song-meta-value">
              <div v-for="(name, idx) in artistRows" :key="'artist-' + idx" class="song-meta-line">{{ name }}</div>
            </div>
            <div v-else class="song-meta-value">-</div>
          </div>
          <div class="song-meta-item song-col-6">
            <div class="song-meta-label">อัลบั้ม</div>
            <div v-if="albumRows.length" class="song-meta-value">
              <div v-for="(name, idx) in albumRows" :key="'album-' + idx" class="song-meta-line">{{ name }}</div>
            </div>
            <div v-else class="song-meta-value">-</div>
          </div>
          <div class="song-meta-item song-col-4">
            <div class="song-meta-label">แนวเพลง</div>
            <div class="song-meta-value">{{ txt(pick(song, ["genre"])) }}</div>
          </div>
          <div class="song-meta-item song-col-4">
            <div class="song-meta-label">ภาษาเพลง</div>
            <div class="song-meta-value">{{ txt(pick(song, ["song_language", "songLanguage", "language"])) }}</div>
          </div>
          <div class="song-meta-item song-col-4">
            <div class="song-meta-label">ความยาวเพลง (วินาที)</div>
            <div class="song-meta-value">{{ txt(pick(song, ["song_duration", "songDuration", "duration"])) }}</div>
          </div>
          <div class="song-meta-item song-col-4">
            <div class="song-meta-label">วันที่เผยแพร่</div>
            <div class="song-meta-value">{{ toThaiDate(pick(song, ["release_date", "releaseDate"])) }}</div>
          </div>
          <div class="song-meta-item song-col-6">
            <div class="song-meta-label">หมายเหตุ</div>
            <div class="song-meta-value">{{ txt(song.note) }}</div>
          </div>
          <div class="song-meta-item song-col-6">
            <div class="song-meta-label">ไฟล์เสียง MP3</div>
            <div class="song-meta-value">{{ txt(song.audio_original_name || song.audioOriginalName) }}</div>
          </div>
          <div class="song-meta-item song-col-6">
            <div class="song-meta-label">ไฟล์วิดีโอ MP4</div>
            <div class="song-meta-value">{{ txt(song.video_original_name || song.videoOriginalName) }}</div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="song-player-card mb-3"
      :class="{ 'is-playing': playing, 'is-dragging': draggingFile && !hasSavedAudio }"
      @dragover.prevent="draggingFile = !hasSavedAudio"
      @dragleave.prevent="draggingFile = false"
      @drop="onAudioDrop"
    >
      <div class="song-player-glow"></div>
      <div class="song-player-art">
        <div class="song-player-disc" :class="{ spinning: playing }">
          <span class="song-player-disc-hole"></span>
          <i class="ri-music-2-fill"></i>
        </div>
        <div class="song-player-eq" aria-hidden="true">
          <span></span><span></span><span></span><span></span><span></span>
        </div>
      </div>
      <div class="song-player-main">
        <div class="d-flex align-items-start justify-content-between gap-2">
          <div>
            <div class="song-player-kicker">{{ hasSavedAudio ? "ไฟล์เสียงที่อัปโหลด" : "Play Audio" }}</div>
            <div class="song-player-title">{{ loading ? "กำลังโหลด..." : pageTitle }}</div>
            <div class="song-player-artist">{{ artistLabel }}</div>
          </div>
          <button v-if="!hasSavedAudio" type="button" class="song-player-chip" @click="openAudioPicker">
            <i class="ri-folder-music-line"></i>
            {{ audioFileName ? "เปลี่ยนไฟล์" : "โหลดไฟล์" }}
          </button>
        </div>
        <div class="song-player-file" v-if="audioFileName">{{ audioFileName }}</div>
        <div class="song-player-row">
          <button type="button" class="song-player-play" @click="togglePlay" :aria-label="playing ? 'หยุดชั่วคราว' : 'เล่น'">
            <i :class="playing ? 'ri-pause-fill' : 'ri-play-fill'"></i>
          </button>
          <span class="song-player-time">{{ formatTime(currentTime) }}</span>
          <input
            class="song-player-seek"
            type="range"
            min="0"
            max="100"
            step="0.1"
            :value="progressPct"
            :disabled="!audioSrc"
            @input="seekAudio"
          >
          <span class="song-player-time">{{ formatTime(duration) }}</span>
          <button type="button" class="song-player-vol-btn" @click="toggleMute" :aria-label="muted ? 'เปิดเสียง' : 'ปิดเสียง'">
            <i :class="muted || volume === 0 ? 'ri-volume-mute-line' : 'ri-volume-up-line'"></i>
          </button>
          <input
            class="song-player-volume"
            type="range"
            min="0"
            max="100"
            step="1"
            :value="muted ? 0 : Math.round(volume * 100)"
            @input="changeVolume"
          >
        </div>
        <div v-if="!audioSrc" class="song-player-hint">ยังไม่มีไฟล์เสียง — ลากไฟล์ MP3 มาวาง หรือกดโหลดไฟล์เพื่อเล่น</div>
      </div>
      <audio
        ref="audioEl"
        :src="audioSrc || undefined"
        preload="metadata"
        @play="onAudioPlay"
        @pause="onAudioPause"
        @timeupdate="onAudioTime"
        @loadedmetadata="onAudioMeta"
        @ended="onAudioEnded"
      ></audio>
      <input ref="audioInput" type="file" accept=".mp3,audio/mpeg" class="d-none" @change="onAudioPicked">
    </div>

    <div v-if="hasSavedVideo || videoSrc" class="song-video-card mb-3">
      <div class="song-video-head">
        <div>
          <div class="song-player-kicker">ไฟล์วิดีโอที่อัปโหลด</div>
          <div class="song-video-name">{{ videoFileName || "ไฟล์วิดีโอ MP4" }}</div>
        </div>
      </div>
      <video
        ref="videoEl"
        class="song-video-el"
        :src="videoSrc || undefined"
        controls
        preload="metadata"
        playsinline
      ></video>
    </div>

    <div class="card">
      <div class="card-header d-flex align-items-center justify-content-between gap-2 flex-wrap">
        <h5 class="card-title mb-0">สมาชิกนักแต่ง / Publisher และสัดส่วน Share</h5>
        <div v-if="showActions" class="d-flex flex-wrap gap-2">
          <a :href="editShareUrl" class="btn btn-sm btn-primary">แก้ไขสมาชิกนักแต่ง / Publisher</a>
          <a :href="editShareUrl" class="btn btn-sm btn-success">+ สมาชิก/Publisher</a>
        </div>
      </div>
      <div class="card-body">
        <div class="row g-3">
          <div v-for="section in roleSections" :key="section.key" class="col-12">
            <div class="song-view-section-title">
              <span class="song-view-section-dot" :class="section.dot"></span>
              <span>{{ section.label }}</span>
            </div>
            <div class="table-responsive song-view-share-grid">
              <table class="table table-sm table-bordered align-middle mb-0">
                <thead class="table-light">
                  <tr>
                    <th rowspan="2">สมาชิก</th>
                    <th rowspan="2">Role</th>
                    <th colspan="3" class="text-center">Own</th>
                    <th colspan="3" class="text-center">Collection</th>
                  </tr>
                  <tr>
                    <th class="text-end">Perf %</th>
                    <th class="text-end">Mech %</th>
                    <th class="text-end">Sync %</th>
                    <th class="text-end">Perf %</th>
                    <th class="text-end">Mech %</th>
                    <th class="text-end">Sync %</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="!section.rows.length">
                    <td colspan="8" class="text-muted">-</td>
                  </tr>
                  <template v-else>
                    <tr v-for="(item, idx) in section.rows" :key="section.key + '-' + idx">
                      <td>
                        {{ txt(item.display_name) }}
                        <div class="text-muted small">รหัส: {{ txt(item.member_code) }}</div>
                      </td>
                      <td><span class="song-view-role-badge">{{ txt(item.role_code) }}</span></td>
                      <td class="text-end">{{ sharePct(item, "own_perf_share", "own_perf_share") }}</td>
                      <td class="text-end">{{ sharePct(item, "own_mech_share", "own_mech_share") }}</td>
                      <td class="text-end">{{ sharePct(item, "own_sync_share", "own_sync_share") }}</td>
                      <td class="text-end">{{ sharePct(item, "collection_perf_share", "collection_perf_share") }}</td>
                      <td class="text-end">{{ sharePct(item, "collection_mech_share", "collection_mech_share") }}</td>
                      <td class="text-end">{{ sharePct(item, "collection_sync_share", "collection_sync_share") }}</td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card mt-3 mb-0">
      <div class="card-header">
        <h5 class="card-title mb-0">ตารางแสดงผลรวมสัดส่วน Share</h5>
      </div>
      <div class="card-body">
        <div class="table-responsive song-view-share-grid">
          <table class="table table-sm table-bordered align-middle mb-0">
            <thead>
              <tr>
                <th>กลุ่ม</th>
                <th class="text-end">Own Perf %</th>
                <th class="text-end">Own Mech %</th>
                <th class="text-end">Own Sync %</th>
                <th class="text-end">Col Perf %</th>
                <th class="text-end">Col Mech %</th>
                <th class="text-end">Col Sync %</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="loading">
                <td colspan="7" class="text-muted">กำลังโหลดข้อมูล...</td>
              </tr>
              <tr v-else-if="error">
                <td colspan="7" class="text-danger">โหลดข้อมูลไม่สำเร็จ</td>
              </tr>
              <template v-else>
                <tr v-for="row in summaryRows" :key="row.label">
                  <td><strong v-if="row.strong">{{ row.label }}</strong><template v-else>{{ row.label }}</template></td>
                  <td class="text-end"><strong v-if="row.strong">{{ pct(row.totals.own_perf_share) }}</strong><template v-else>{{ pct(row.totals.own_perf_share) }}</template></td>
                  <td class="text-end"><strong v-if="row.strong">{{ pct(row.totals.own_mech_share) }}</strong><template v-else>{{ pct(row.totals.own_mech_share) }}</template></td>
                  <td class="text-end"><strong v-if="row.strong">{{ pct(row.totals.own_sync_share) }}</strong><template v-else>{{ pct(row.totals.own_sync_share) }}</template></td>
                  <td class="text-end"><strong v-if="row.strong">{{ pct(row.totals.collection_perf_share) }}</strong><template v-else>{{ pct(row.totals.collection_perf_share) }}</template></td>
                  <td class="text-end"><strong v-if="row.strong">{{ pct(row.totals.collection_mech_share) }}</strong><template v-else>{{ pct(row.totals.collection_mech_share) }}</template></td>
                  <td class="text-end"><strong v-if="row.strong">{{ pct(row.totals.collection_sync_share) }}</strong><template v-else>{{ pct(row.totals.collection_sync_share) }}</template></td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.song-view-share-grid {
  border: 1px solid #dbeafe;
  border-radius: 0.85rem;
  overflow: hidden;
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.04);
}
.song-view-share-grid .table {
  margin-bottom: 0;
  background: #fff;
}
.song-view-share-grid thead th {
  vertical-align: middle;
  font-size: 0.78rem;
  letter-spacing: 0.01em;
  border-color: #dbeafe !important;
}
.song-view-share-grid thead tr:first-child th {
  background: #eaf2ff !important;
  color: #1e3a8a;
  font-weight: 700;
}
.song-view-share-grid thead tr:nth-child(2) th {
  background: #f7fbff !important;
  color: #334155;
  font-weight: 600;
}
.song-view-share-grid tbody tr:nth-child(odd) {
  background: #fcfdff;
}
.song-view-share-grid td {
  border-color: #e2e8f0 !important;
  vertical-align: middle;
  font-size: 0.82rem;
}
.song-view-role-badge,
.song-view-role-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 2rem;
  padding: 0.15rem 0.45rem;
  border-radius: 999px;
  font-weight: 700;
  font-size: 0.72rem;
  background: #f1f5f9;
  color: #334155;
  border: 1px solid #cbd5e1;
}
.song-view-section-title {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.6rem;
  font-size: 0.95rem;
  font-weight: 700;
  color: #1e293b;
}
.song-view-section-title {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.6rem;
  font-size: 0.95rem;
  font-weight: 700;
  color: #1e293b;
}
.song-view-section-dot {
  width: 0.55rem;
  height: 0.55rem;
  border-radius: 50%;
  display: inline-block;
}
.song-view-section-dot {
  width: 0.55rem;
  height: 0.55rem;
  border-radius: 50%;
  display: inline-block;
}
.song-view-section-dot.melody,
.song-view-section-dot.melody { background: #2563eb; }
.song-view-section-dot.lyrics,
.song-view-section-dot.lyrics { background: #16a34a; }
.song-view-section-dot.arrangement,
.song-view-section-dot.arrangement { background: #7c3aed; }
.song-view-section-dot.publisher,
.song-view-section-dot.publisher { background: #0891b2; }
.song-meta-grid {
  display: grid;
  grid-template-columns: repeat(12, minmax(0, 1fr));
  gap: 0.75rem;
}
.song-meta-item {
  border: 1px solid #e2e8f0;
  border-radius: 0.75rem;
  background: #fff;
  padding: 0.7rem 0.85rem;
  min-height: 70px;
}
.song-meta-item--primary {
  border-color: #bfdbfe;
  background: linear-gradient(135deg, #f8fbff 0%, #eef6ff 100%);
}
.song-meta-label {
  font-size: 0.75rem;
  color: #64748b;
  margin-bottom: 0.2rem;
}
.song-meta-value {
  font-size: 0.95rem;
  font-weight: 600;
  color: #0f172a;
  word-break: break-word;
}
.song-meta-line + .song-meta-line {
  margin-top: 0.28rem;
  padding-top: 0.28rem;
  border-top: 1px dashed #e2e8f0;
}
.song-col-3 { grid-column: span 3; }
.song-col-4 { grid-column: span 4; }
.song-col-6 { grid-column: span 6; }
.song-col-8 { grid-column: span 8; }
.song-col-12 { grid-column: span 12; }
@media (max-width: 991.98px) {
  .song-col-3, .song-col-4, .song-col-6, .song-col-8 { grid-column: span 6; }
}
@media (max-width: 575.98px) {
  .song-col-3, .song-col-4, .song-col-6, .song-col-8, .song-col-12 { grid-column: span 12; }
}

.song-player-card {
  position: relative;
  display: flex;
  align-items: center;
  gap: 1.25rem;
  padding: 1.15rem 1.35rem;
  border-radius: 1.35rem;
  overflow: hidden;
  color: #fff;
  background:
    radial-gradient(circle at 12% 20%, rgba(96, 165, 250, 0.35), transparent 42%),
    radial-gradient(circle at 88% 80%, rgba(167, 139, 250, 0.28), transparent 46%),
    linear-gradient(135deg, #0f172a 0%, #1e3a8a 52%, #312e81 100%);
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.22);
}
.song-player-card.is-dragging {
  outline: 2px dashed rgba(191, 219, 254, 0.85);
  outline-offset: -8px;
}
.song-player-glow {
  position: absolute;
  inset: auto -20% -40% auto;
  width: 16rem;
  height: 16rem;
  border-radius: 50%;
  background: rgba(96, 165, 250, 0.18);
  filter: blur(18px);
  pointer-events: none;
}
.song-player-art {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.65rem;
  flex: 0 0 auto;
}
.song-player-disc {
  position: relative;
  width: 5.5rem;
  height: 5.5rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background:
    repeating-radial-gradient(circle at center, rgba(15, 23, 42, 0.18) 0 2px, transparent 2px 6px),
    linear-gradient(145deg, #93c5fd, #1d4ed8 48%, #1e1b4b);
  box-shadow: inset 0 0 0 6px rgba(15, 23, 42, 0.18), 0 10px 24px rgba(15, 23, 42, 0.35);
  font-size: 1.6rem;
}
.song-player-disc.spinning {
  animation: song-disc-spin 4.5s linear infinite;
}
.song-player-disc-hole {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0.85rem;
  height: 0.85rem;
  border-radius: 50%;
  background: #0f172a;
  box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.35);
  transform: translate(-50%, -50%);
  z-index: 1;
}
.song-player-disc i {
  position: relative;
  z-index: 2;
  font-size: 1.35rem;
}
.song-player-eq {
  display: flex;
  align-items: flex-end;
  gap: 3px;
  height: 16px;
}
.song-player-eq span {
  width: 3px;
  height: 6px;
  border-radius: 99px;
  background: rgba(191, 219, 254, 0.75);
}
.song-player-card.is-playing .song-player-eq span {
  animation: song-eq-bounce 0.9s ease-in-out infinite;
}
.song-player-eq span:nth-child(2) { animation-delay: 0.12s; }
.song-player-eq span:nth-child(3) { animation-delay: 0.24s; }
.song-player-eq span:nth-child(4) { animation-delay: 0.08s; }
.song-player-eq span:nth-child(5) { animation-delay: 0.2s; }
.song-player-main {
  position: relative;
  z-index: 1;
  min-width: 0;
  flex: 1 1 auto;
}
.song-player-kicker {
  font-size: 0.7rem;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #bfdbfe;
  margin-bottom: 0.15rem;
}
.song-player-title {
  font-size: 1.15rem;
  font-weight: 700;
  line-height: 1.3;
  word-break: break-word;
}
.song-player-artist {
  font-size: 0.85rem;
  color: #c7d2fe;
  margin-top: 0.1rem;
}
.song-player-chip {
  border: 0;
  border-radius: 999px;
  padding: 0.35rem 0.75rem;
  font-size: 0.75rem;
  font-weight: 600;
  color: #e0e7ff;
  background: rgba(255, 255, 255, 0.12);
  white-space: nowrap;
}
.song-player-chip:hover {
  background: rgba(255, 255, 255, 0.2);
  color: #fff;
}
.song-player-file {
  margin-top: 0.35rem;
  font-size: 0.75rem;
  color: #cbd5e1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.song-player-row {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  margin-top: 0.85rem;
}
.song-player-play {
  width: 2.6rem;
  height: 2.6rem;
  border: 0;
  border-radius: 50%;
  flex: 0 0 auto;
  color: #1e3a8a;
  background: #fff;
  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.25);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 1.35rem;
}
.song-player-play:hover {
  transform: scale(1.04);
}
.song-player-time {
  font-size: 0.75rem;
  font-variant-numeric: tabular-nums;
  color: #dbeafe;
  min-width: 2.25rem;
}
.song-player-seek,
.song-player-volume {
  -webkit-appearance: none;
  appearance: none;
  height: 5px;
  border-radius: 99px;
  background: rgba(255, 255, 255, 0.22);
  outline: none;
}
.song-player-seek {
  flex: 1 1 auto;
  min-width: 4rem;
}
.song-player-volume {
  width: 4.5rem;
  flex: 0 0 auto;
}
.song-player-seek::-webkit-slider-thumb,
.song-player-volume::-webkit-slider-thumb {
  -webkit-appearance: none;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background: #fff;
  border: 0;
  box-shadow: 0 0 0 4px rgba(255, 255, 255, 0.16);
}
.song-player-vol-btn {
  border: 0;
  background: transparent;
  color: #e0e7ff;
  font-size: 1.15rem;
  padding: 0;
  line-height: 1;
}
.song-player-hint {
  margin-top: 0.55rem;
  font-size: 0.78rem;
  color: #bfdbfe;
}
@keyframes song-disc-spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
@keyframes song-eq-bounce {
  0%, 100% { height: 5px; }
  50% { height: 16px; }
}
@media (max-width: 767.98px) {
  .song-player-card {
    flex-direction: column;
    align-items: stretch;
    text-align: left;
  }
  .song-player-art {
    flex-direction: row;
    justify-content: flex-start;
  }
  .song-player-volume {
    display: none;
  }
}
.song-video-card {
  border-radius: 1.2rem;
  overflow: hidden;
  background: #0f172a;
  color: #e2e8f0;
  box-shadow: 0 16px 36px rgba(15, 23, 42, 0.18);
}
.song-video-head {
  padding: 0.9rem 1.1rem 0.4rem;
}
.song-video-name {
  font-weight: 600;
  font-size: 0.95rem;
  word-break: break-word;
}
.song-video-el {
  display: block;
  width: 100%;
  max-height: 420px;
  background: #000;
}
</style>
